import { useEffect, useState } from "react";
import { site } from "../data/site";
import { useContact } from "./ContactProvider";
import ThemeToggle from "./ThemeToggle";

const links = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { open } = useContact();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#050505]/70 border-b border-[#262626]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-2 h-2 bg-[#E3FF34] inline-block group-hover:rotate-45 transition-transform duration-500" />
          <span className="font-['Outfit'] font-medium tracking-tight text-[#F2F2F2]">
            {site.brand}
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#A3A3A3] hover:text-[#E3FF34] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 md:gap-3">
          <ThemeToggle />
          <button
            type="button"
            onClick={() => open()}
            data-testid="nav-contact-btn"
            className="hidden md:inline-flex items-center gap-2 font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] px-4 py-2 border border-[#262626] text-[#F2F2F2] hover:border-[#E3FF34] hover:text-[#E3FF34] transition-colors"
          >
            Start a project
            <span aria-hidden>→</span>
          </button>
          <button
            type="button"
            onClick={() => open()}
            data-testid="nav-contact-btn-mobile"
            className="md:hidden font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#E3FF34]"
          >
            Hello →
          </button>
        </div>
      </div>
    </header>
  );
}
